<template>
  <div :class="{ show: show }" class="mobile-filter-popup">
    <Icon icon-key="close" hover-type="OPACITY" class="close-container" :on-click="hideFilters" />
    <h2 class="popup-title">{{ title }}</h2>
    <div class="mobile-filter-scroll-section">
      <filter-badges v-if="!displayQuickFilters" class="mobile-filter-badges" />
      <quick-filters v-else class="mx-10" />

      <filter-panel
        :total-count="totalCount"
        is-mobile
        class="mobile-filter-panel"
        :filter-panel-config="filterPanelConfig"
        :is-buyer="isBuyer"
        :display-quick-filters="displayQuickFilters"
        :trade-show-details="tradeShowDetails"
      />
    </div>
    <div class="view-results">
      <span data-test-id="button_clear_all" class="body-copy-1 underline pointer" @click="clearAllFilters">
        Clear All
      </span>
      <bulletin-button variant="primary" @click="hideFilters()"> View Results </bulletin-button>
    </div>
  </div>
</template>

<script>
import { FilterKeys, QuickFilterKeys } from '../../../services/utils'
import { bodyScrollHelper } from '../../mixin/bodyScrollHelper'
import QuickFilters from './QuickFilters'

export default {
  components: {
    QuickFilters
  },
  mixins: [bodyScrollHelper],
  props: {
    title: {
      type: String,
      default: 'Filters'
    },
    show: {
      type: Boolean,
      default: false
    },
    totalCount: {
      type: Number,
      default: 0
    },
    hideFilters: {
      type: Function,
      default: () => {}
    },
    filterPanelConfig: {
      type: Object,
      default: () => {}
    },
    isBuyer: {
      type: Boolean,
      default: false
    },
    displayQuickFilters: {
      type: Boolean,
      default: false
    },
    tradeShowDetails: {
      type: Object,
      default: function () {
        return {
          brand: '',
          eventId: ''
        }
      }
    }
  },
  methods: {
    clearAllFilters() {
      const params = new URLSearchParams(window.location.search)

      for (const key of Object.keys(FilterKeys)) {
        const keyLower = key.toLowerCase()
        if (keyLower !== 'keyword') params.delete(keyLower)
      }
      for (const key of Object.keys(QuickFilterKeys)) {
        params.delete(key.toLowerCase())
      }
      localStorage.removeItem('BULLETIN_PICKS')

      this.$router.replace({ path: this.$route.path, query: Object.fromEntries(params.entries()) })
      this.hideFilters()
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/sass/base/_vars.scss';

.mobile-filter-popup {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  display: none;
  background: $color-white;
  z-index: 26;
  &.show {
    display: flex;
    flex-direction: column;
  }

  .mobile-filter-badges {
    padding-left: 16px;
    padding-right: 16px;
  }

  .mobile-filter-panel {
    padding: 0 16px;
    margin-top: 8px;
  }

  .mobile-filter-scroll-section {
    flex-grow: 1;
    overflow: auto;
  }

  .view-results {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-top: 1px solid $color-black;
    background: $color-white;
    z-index: 2;
  }

  .popup-title {
    padding-top: 48px;
    padding-left: 16px;
    padding-bottom: 16px;
    font-size: 32px;
  }

  .close-container {
    position: fixed;
    top: 16px;
    right: 16px;
  }
}
</style>
